import cloneDeep from 'lodash/cloneDeep';

import {Action, canPerformPropertyAggregation, QuerySegmentEntry} from 'common/widgets/query-entry-section/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {PropertyType} from 'common/report/constants';

import {BaseEntryRow} from '../base';
import type {EntryRow} from '../base/types';
import {SegmentEntryRowEl} from './template';

export class SegmentEntryRow extends BaseEntryRow<QuerySegmentEntry> implements EntryRow<QuerySegmentEntry> {
  template = SegmentEntryRowEl;

  isPlaceholder() {
    if (
      !this.hasEventValue(this.entry) ||
      !this.entry.filters.every((filter) => new PropertyFilter(filter).isValid())
    ) {
      return true;
    }

    if (canPerformPropertyAggregation(this.entry.type)) {
      return !this.hasPropertyValue();
    }

    return false;
  }

  hasPropertyValue() {
    const {property} = this.entry;
    return Boolean(property && (property.value || property.customPropertyId));
  }

  hasEventValue(entry: QuerySegmentEntry = this.entry) {
    // When adding a new row for filter/segment, the entry will be initialized to null. For other entry types,
    // a placeholder entry is used with `value` field null.
    return !!entry?.event;
  }

  getPropertyType(): PropertyType {
    // Return the property type of first entry
    try {
      return Object.values(this.entry.event[0])[0].propertyType;
    } catch (err) {
      throw Error(`Reached code that should be unreachable.`);
    }
  }

  setPropertyType(toType: PropertyType) {
    const entry = cloneDeep(this.entry);
    entry.event.forEach((segment) => {
      for (const key in segment) {
        const segmentation = segment[key];
        if (segmentation.propertyType !== toType) {
          segmentation.propertyType = toType;
          segmentation.customBucket = null;
          segmentation.unit = null;
          segment[key] = segmentation;
        }
      }
    });
    this.section.updateEntries(Action.Edit, {entry, index: this.index});
  }
}
